import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M20.431 5.46399H3.56998C2.57698 5.46399 2.00098 5.88799 2.00098 7.03299V16.967C2.00098 17.93 2.57698 18.536 3.56998 18.536H20.432C21.384 18.536 22.001 17.931 22.001 16.967V7.03299C22 5.90899 21.399 5.46399 20.431 5.46399V5.46399ZM20.199 8.17399C16.505 10.706 12.824 13.085 11.885 13.085C10.945 13.085 7.27498 10.67 3.59598 8.13699C3.31998 7.94799 3.25798 7.57999 3.45698 7.31699C3.65598 7.05399 4.04098 6.99399 4.31798 7.18399C7.89398 9.64599 11.071 11.664 11.885 11.901C12.7 11.665 15.887 9.68199 19.48 7.21899C19.757 7.02899 20.142 7.08999 20.341 7.35299C20.539 7.61699 20.476 7.98399 20.199 8.17399V8.17399Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'EnvelopeFill');

export default Icon;
